import { render, staticRenderFns } from "./OTAdjustView.vue?vue&type=template&id=4dabd1da&scoped=true&lang=pug"
import script from "./OTAdjustView.vue?vue&type=script&lang=js"
export * from "./OTAdjustView.vue?vue&type=script&lang=js"
import style0 from "./OTAdjustView.vue?vue&type=style&index=0&id=4dabd1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabd1da",
  null
  
)

export default component.exports